export interface GovernanceState {
    governanceList: Array<any> | null;
    governanceByFieldList: Array<any> | null;
    governanceById: any;
    addGovernanceResponse: any;
    updateGovernanceResponse: any;
    deleteGovernanceResponse: any;
    searchOption: Array<any>;
    validateStartDateResp: any;
}

export const initialState: GovernanceState = {
    governanceList: null,
    governanceByFieldList: null,
    governanceById: null,
    addGovernanceResponse: null,
    updateGovernanceResponse: null,
    deleteGovernanceResponse: null,
    searchOption: [],
    validateStartDateResp: null
}
